import { Component, h } from 'preact'
import {PostType, TopicTypes} from './Types'
import Content from '../common/Content'
import PostEditor from '../editor/postEditorViaAPI'
import PostAuthor from './PostAuthorAvatar'
import PostAuthorMeta from './PostAuthorMeta'
import TopicLike from './TopicLike'
import Axios from 'axios'
import LikedUsers, { LikedUserType } from '../topic-list-view/LikedUsers'
import TopicMore from '../topic-list-view/TopicMore'
import Phrase from '../../libs/translationsUtils/phrase'
import classNames from 'classnames'
import PinnedReplyLabel from '../pinned-reply/PinnedReplyLabel'
import { canUserEditPost } from '../utils/permissions'

interface Props {
  type: TopicTypes,
  currentUser: LikedUserType,
  displayAuthor: boolean,
  isLastItem: boolean,
  topicId: number,
  reply: PostType,
  isPinned?: boolean
}

interface State {
  showEditor: boolean,
  isCurrentUserLiked: boolean,
  likedUsers: {
    [key: string]: LikedUserType
  },
  content: string
}

class TopicReply extends Component<Props, State> {
  private canUserEditPost: boolean = canUserEditPost()
  constructor (props: Props) {
    super(props)
    this.state = {
      showEditor: false,
      isCurrentUserLiked: this.props.currentUser.id !== null && this.props.reply.likedBy.includes(this.props.currentUser.id.toString()),
      likedUsers: {},
      content: props.reply.content
    }

    this.toggleLikeStatus = this.toggleLikeStatus.bind(this)
  }

  async toggleLikeStatus () {
    if (this.props.currentUser.id === null) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    const likedUsersBeforeUpdate: {
      [key: string]: LikedUserType
    } = Object.assign({}, this.state.likedUsers)

    if (this.state.isCurrentUserLiked) {
      delete this.state.likedUsers[this.props.currentUser.id]
      this.setState({ likedUsers: this.state.likedUsers, isCurrentUserLiked: false })
      try {
        await Axios.post(`/community/api/${this.props.type}/replies/${this.props.reply.id}/unlike`, {
          unlikedBy: this.props.currentUser.id
        }, {
          params: {
            unlikedBy: this.props.currentUser.id
          }
        })
      } catch {
        this.setState({ likedUsers: likedUsersBeforeUpdate, isCurrentUserLiked: true })
      }
    } else {
      this.setState({ likedUsers: { ...this.state.likedUsers, [this.props.currentUser.id]: this.props.currentUser }, isCurrentUserLiked: true })
      try {
        await Axios.post(`/community/api/${this.props.type}/replies/${this.props.reply.id}/like`, {
          likedBy: this.props.currentUser.id
        },{
            params: {
              likedBy: this.props.currentUser.id
            }
          }
        )
      } catch {
        this.setState({ likedUsers: likedUsersBeforeUpdate, isCurrentUserLiked: false })
      }
    }
  }

  async componentDidMount () {
    if (this.props.reply.likedBy.length) {
      const res = await Axios.get('/member/getUsersById', {
        params: {
          ids: this.props.reply.likedBy
        }
      })

      this.setState({ likedUsers: res.data })
    }
  }

  render ({ topicId, reply, displayAuthor, isLastItem, type, isPinned }: Props, { content, showEditor, isCurrentUserLiked, likedUsers }: State) {
    return (
        <div id={`post${reply.id}`} className={classNames(
            'post', 'box__pad', 'qa-topic-post-box',
            { 'post--pinned': isPinned }
        )}>
        <div className='post__user__info'>
          <PostAuthor author={reply.author} />
        </div>
        <PostAuthorMeta {...reply.author} displayAuthor={displayAuthor} repliedAt={reply.repliedAt} />
        {
          showEditor ? (
            <div className='post__content post__edit'>
              <PostEditor
                type={type}
                data={content}
                disableFileAttachments={false}
                topicId={topicId}
                replyId={reply.id}
                isControl={false}
                onSuccess={(content) => this.setState({ showEditor: false, content })}
                onCancel={() => this.setState({ showEditor: false })}
                redirect={false}
                isGuest={false}
              />
            </div>
          ) : (
              <div>
                { isPinned && <div className='pinned-reply__label--comments'>
                  <PinnedReplyLabel phrase={<Phrase p='reply.pinned' m='Forum' />} />
                </div>}
                <Content
                  content={content || ''}
                  className='post__content qa-topic-post-content post__content--new-editor'
                />
              </div>
          )
        }
        {
          Object.keys(likedUsers).length ? (
            <LikedUsers likedUsers={Object.keys(likedUsers).map(id => likedUsers[id])} previewCount={3} isCurrentUserLiked={isCurrentUserLiked} />
          ) : null
        }
        <div className='post__footer post__footer-wrapper qa-topic-post-footer'>
          <TopicLike className={`${isCurrentUserLiked ? 'active' : ''}`} onClick={this.toggleLikeStatus} />
          {
            this.canUserEditPost ? (
              <TopicMore>
                <li onClick={() => this.setState({ showEditor: true })}><Phrase p='Edit' /></li>
              </TopicMore>
            ) : null
          }
        </div>
        <hr className={`seperator m-b-0 ${isLastItem ? 'is-transparant' : ''}`} />
      </div>
    )
  }
}

export default TopicReply
